import React from 'react';
import { Link } from 'react-router-dom';

// What the chains sell as "private theatre rentals," StarView does better:
// ticket-gated watch parties synced to the second, hosted from anywhere,
// with friends in any of 199 markets. This page sells it; hosting lives in
// the app (a Blast Pass perk).
const STEPS = [
  ['1', 'Pick the film', 'Any film showing on your country screen - your party rides a real showtime.'],
  ['2', 'Invite your people', 'Friends join by invite or code. Everyone needs a ticket - the box office handles it.'],
  ['3', 'Roll the show', 'Playback syncs to the second for every guest, wherever on Earth they sit.'],
];

export default function WatchParties() {
  return (
    <main style={{ minHeight: '70vh', background: '#0b0c1e', color: '#fff', padding: '110px 20px 60px' }}>
      <div style={{ maxWidth: 820, margin: '0 auto', textAlign: 'center' }}>
        <p style={{ fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#CFAA41', fontWeight: 700 }}>StarView Party</p>
        <h1 style={{ fontSize: 36, margin: '6px 0' }}>Your own premiere night. Any country. Same second.</h1>
        <p style={{ opacity: 0.75, maxWidth: 560, margin: '0 auto 30px' }}>
          Other cinemas rent you a room. StarView gives you a synchronized private screening with friends
          across the world - birthdays, premieres, film clubs, long-distance movie nights.
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14, textAlign: 'left', marginBottom: 30 }}>
          {STEPS.map(([n, title, body]) => (
            <div key={n} style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 14, padding: '18px 18px' }}>
              <div style={{ color: '#CFAA41', fontWeight: 800, fontSize: 13, letterSpacing: '0.1em' }}>STEP {n}</div>
              <h3 style={{ margin: '6px 0 6px', fontSize: 17 }}>{title}</h3>
              <p style={{ opacity: 0.72, margin: 0, fontSize: 14 }}>{body}</p>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/get-the-app" style={{ background: '#CFAA41', color: '#141021', fontWeight: 800, borderRadius: 999, padding: '13px 30px', textDecoration: 'none' }}>Host in the app</Link>
          <Link to="/Showtimes" style={{ background: 'transparent', color: '#fff', fontWeight: 800, borderRadius: 999, padding: '13px 30px', border: '1px solid rgba(255,255,255,0.4)', textDecoration: 'none' }}>Get tickets first</Link>
        </div>
        <p style={{ opacity: 0.55, fontSize: 13, marginTop: 14 }}>Hosting is a Blast Pass perk. Guests just need a ticket for the film.</p>
      </div>
    </main>
  );
}
